import React, { useState, useEffect } from "react";
import Button from "./Button";
import SelectedMedia from "../sections/admin/SelectedMediaModal/SelectedMedia";

const SelectImageGallery = ({
  label,
  labelClasses = "",
  required = false,
  errorType,
  errorText,
  onChange = () => {},
  onRemove = () => {},
  values = [],
}) => {
  const [mediaItems, setMediaItems] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    if (Array.isArray(values)) {
      setMediaItems(values);
    }
  }, [JSON.stringify(values)]);

  const handleMediaSelect = (selectedMedia) => {
    setMediaItems(selectedMedia);
    onChange(selectedMedia);
    setModalOpen(false);
  };

  const handleRemove = (index) => {
    const updated = mediaItems.filter((_, i) => i !== index);
    setMediaItems(updated);
    onRemove(updated);
    onChange(updated);
  };

  return (
    <div className="w-full relative">
      {label && (
        <div className={`text-xs font-medium text-text-disabled mb-1 font-CanelaDeck ${labelClasses}`}>
          {label}
          {required && (
            <span className="text-[8px] text-red-500 ml-1 absolute top-[-2px]">
              <i className="fa-solid fa-asterisk"></i>
            </span>
          )}
        </div>
      )}

      <div className="mt-2 flex flex-wrap gap-2">
        <div
          onClick={() => setModalOpen(true)}
          className="w-20 h-20 flex rounded-md border border-slate-300 border-dashed items-center justify-center cursor-pointer text-slate-400"
        >
          <i className="fa-solid fa-folder-open text-3xl"></i>
        </div>

        {mediaItems.map((item, index) => (
          <div key={index} className="relative w-20 h-20">
            {item?.mediaType === "image" && item?.url ? (
              <img src={item?.url} alt="Selected media" className="w-full h-full object-cover rounded-md" />
            ) : (
              <video src={item?.url} className="w-full h-full object-cover" muted autoPlay loop />
            )}
            <Button
              type="button"
              buttonClasses="!absolute top-1 right-1 !bg-chestnut-rose !text-red !text-xs rounded-full !h-4 !w-4 !p-0"
              buttonIcon={"fa-light fa-xmark"}
              buttonIconPosition={"left"}
              buttonFunction={() => handleRemove(index)}
            />
          </div>
        ))}
      </div>

      {errorType && (
        <div
          className={`text-xs mt-1 ${
            errorType === "error"
              ? "text-red-600"
              : errorType === "warning"
              ? "text-amber-600"
              : errorType === "success"
              ? "text-green-600"
              : "text-sky-600"
          }`}
        >
          <i
            className={`fa-regular fa-fw ${
              errorType === "error"
                ? "fa-square-exclamation"
                : errorType === "warning"
                ? "fa-triangle-exclamation"
                : errorType === "success"
                ? "fa-circle-check"
                : "fa-circle-info"
            } text-sm mr-1`}
          ></i>
          {errorText}
        </div>
      )}

      <SelectedMedia
        open={modalOpen}
        close={() => setModalOpen(false)}
        onSelect={handleMediaSelect}
        selectedData={mediaItems.map((m) => m._id)}
        isSingle={false}
      />
    </div>
  );
};

export default SelectImageGallery;
